// extracted by mini-css-extract-plugin
module.exports = {"GallerySection":"GallerySection_GallerySection__21x13","ContainerTitle":"GallerySection_ContainerTitle__SiM6C","Grid":"GallerySection_Grid__2J5v1"};